<template>
    <div>
        <div class="VueTables__primary-content">{{ data.name }}</div>
        <div class="VueTables__secondary-content">{{ data.prefixed_name }}</div>
    </div>
</template>

<script>
    export default {
        props: ['data', 'index', 'column'],
    }
</script>
